import { render, staticRenderFns } from "./TaskDetailEdit.vue?vue&type=template&id=076ebfd2&scoped=true"
import script from "./TaskDetailEdit.vue?vue&type=script&lang=js"
export * from "./TaskDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailEdit.vue?vue&type=style&index=0&id=076ebfd2&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ebfd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076ebfd2')) {
      api.createRecord('076ebfd2', component.options)
    } else {
      api.reload('076ebfd2', component.options)
    }
    module.hot.accept("./TaskDetailEdit.vue?vue&type=template&id=076ebfd2&scoped=true", function () {
      api.rerender('076ebfd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/taskDetail/TaskDetailEdit.vue"
export default component.exports